import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Account } from "model";
/**
* @class UnlinkedAccount
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.unlinkedAccounts[0];
* const linkedAccount = new UnlinkedAccount(record);
* @property {NUMBER} _mapID - The mapID of the Account.
* @property {STRING} _subtype - The mapID of the Account.
* @property {STRING} _accountOwnerFirstName - The accountOwnerFirstName of the Account.
* @property {STRING} _accountOwnerLastName - The accountOwnerLastName of the Account.
* @property {STRING} _accountOwner - The accountOwner of the account.
* @property {STRING} _accountOwnerType - The accountOwnerType for the account.
* @property {BCMSDate} _dateAdded - The dateAdded for the account.
*
* @description These properties are the same as an "Account" but there are a few 
additional properties like "accountOwner" and "accountOwnerType".
* 
*/

export default class UnlinkedAccount extends BCMSRecord {
  _mapID
  _subtype
  _accountOwnerFirstName
  _accountOwnerLastName
  _accountOwner
  _accountOwnerType
  _dateAdded

  constructor(record) {
    // "record.mapID" is undefined in the case where we are initializing
    // "BCMSDefaultModel.unlinkedAccount()" since the id will be set later in the code.
    const account = record.mapID ? Account.initByID(record.mapID) :  Account.init(record);
    super(Object.assign(record, account.record));
  }

  /** 
  * @function initAll   
  * @static
  * @property {VOID} - No parameters
  * @description Returns all unlinked accounts.
  * @example const accounts = UnlinkedAccount.initAll();
  * @memberof UnlinkedAccount 
  */
  static initAll() {
    const accounts = this._GlobalController.state[this._RecordType]

    return accounts.map((record) => {
        return Account.initByType(record.mapID);
    });
  }
}

UnlinkedAccount.define({
  "recordType": "unlinkedAccounts",
  "recordIDProp": "mapID",
  "className" : "UnlinkedAccount",
  "recordProperties": [

   /** 
    * @name mapID
    * @instance
    * @property get {NUMBER} - gets the mapID of the account
    * @property set {NUMBER} - sets the mapID of the account
    * @memberof UnlinkedAccount 
    */

    BCMSRecordProperty.mapToNumber("mapID", "_mapID"),

    /** 
    * @name subtype
    * @instance
    * @property get {STRING} - gets the subtype of the account
    * @property set {STRING} - sets the subtype of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToString("subtype", "_subtype"),

    /** 
    * @name accountOwnerFirstName
    * @instance
    * @property get {STRING} - gets the accountOwner of the account
    * @property set {STRING} - sets the accountOwner of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToString("accountOwnerFirstName", "_accountOwnerFirstName"),

    /** 
    * @name accountOwnerLastName
    * @instance
    * @property get {STRING} - gets the accountOwner of the account
    * @property set {STRING} - sets the accountOwner of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToString("accountOwnerLastName", "_accountOwnerLastName"),

        /** 
    * @name accountOwner
    * @instance
    * @property get {STRING} - gets the accountOwner of the account
    * @property set {STRING} - sets the accountOwner of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToString("accountOwner", "_accountOwner"),

    /** 
    * @name accountOwnerType
    * @instance
    * @property get {STRING} - gets the accountOwnerType of the account
    * @property set {STRING} - sets the accountOwnerType of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToString("accountOwnerType", "_accountOwnerType"),

    /** 
    * @name dateAdded
    * @instance
    * @property get {STRING} - gets the accountOwnerType of the account
    * @property set {STRING} - sets the accountOwnerType of the account
    * @memberof UnlinkedAccount 
    */
    BCMSRecordProperty.mapToDate("dateAdded", "_dateAdded"),

  ].concat(Account._RecordProperties)
})




